var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: {
        inline: false,
        model: _vm.reappraisalBoardMemberJudgment,
        "label-width": "180px"
      }
    },
    [
      _vm.isReappraisal && this.workingApplication.overdue
        ? _c(
            "el-form-item",
            [
              _c("el-alert", {
                staticStyle: {
                  border: "1px solid",
                  "background-color": "#fdf6ec"
                },
                attrs: {
                  closable: false,
                  type: "warning",
                  title: _vm.OVERDUE_MESSAGE,
                  "show-icon": ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Κατηγορία αίτησης" } },
            [
              _c("el-switch", {
                attrs: {
                  disabled: "",
                  "active-text": "Νομικό ζήτημα",
                  "inactive-text": "Ακαδημαϊκό ζήτημα"
                },
                model: {
                  value: _vm.workingApplication.legalIssue,
                  callback: function($$v) {
                    _vm.$set(_vm.workingApplication, "legalIssue", $$v)
                  },
                  expression: "workingApplication.legalIssue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("proposals"),
      _vm._v(" "),
      _c("internalComments"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Επιτροπή Επανεξέτασης" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.membersDecisions }
            },
            [
              _c(
                "el-table-column",
                { attrs: { label: "Αποφάσεις Μελών", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "Ονοματεπώνυμο" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.isReappraisal
                    ? _c("el-table-column", {
                        attrs: {
                          label: "Πλήρης αποδοχή",
                          width: "150",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.fullyAgreeWithReappraisal === 1
                                  ? _c("span", { staticClass: "agree-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.fullyAgreeWithReappraisal === 0
                                  ? _c(
                                      "span",
                                      { staticClass: "disagree-btn" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-close"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.fullyAgreeWithReappraisal === null
                                  ? _c("span", { staticClass: "pending-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Συντονιστής",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.isLeader === true
                              ? _c("span", { staticClass: "done-btn" }, [
                                  _c("i", { staticClass: "el-icon-check" })
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Εισήγηση επιτροπής" } },
        [
          _vm.reappraisalProposalFound
            ? _c("el-alert", {
                attrs: {
                  type: "success",
                  title: "Είναι αναρτημένη στην καρτέλα Επισυναπτόμενα",
                  "show-icon": "",
                  closable: false
                }
              })
            : _c("el-alert", {
                attrs: {
                  type: "error",
                  title: "Δεν υπάρχει αναρτημένη Εισήγηση",
                  "show-icon": "",
                  closable: false
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCurrentUserLeader
        ? _c(
            "el-form-item",
            { attrs: { label: "Ανάρτηση εγγράφων" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.onDocTypeChange },
                  model: {
                    value: _vm.uploadedDocType,
                    callback: function($$v) {
                      _vm.uploadedDocType = $$v
                    },
                    expression: "uploadedDocType"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        label: 1006,
                        disabled: _vm.reappraisalProposalFound
                      }
                    },
                    [_vm._v("Εισήγηση")]
                  ),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1014 } }, [
                    _vm._v("Συνοδευτικό έγγραφο")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploading,
                      expression: "this.uploading"
                    }
                  ],
                  ref: "uploadReappraisalProposalRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.reappBoardAttachments,
                    "http-request": _vm.addAttachment,
                    "on-remove": _vm.handleRemove,
                    "on-preview": _vm.viewPdf,
                    "before-remove": _vm.handleBeforeRemove,
                    action: "",
                    limit: 10,
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary"
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.handleBeforeTrigger($event)
                        }
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** Μ Ο Ν Ο για μία (1) εισήγηση της Ειδ. Επιτρ. Επανεξέτασης ή/και άλλα συνοδευτικά έγγραφα (αρχεία pdf μεγέθους μέχρι 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCurrentUserLeader
        ? _c(
            "el-form-item",
            [
              _c("el-checkbox", {
                attrs: {
                  label: "Επιστροφή της αίτησης στον Πρόεδρο",
                  disabled: _vm.reappraisalProposalFound
                },
                model: {
                  value: _vm.returnToPresident,
                  callback: function($$v) {
                    _vm.returnToPresident = $$v
                  },
                  expression: "returnToPresident"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.returnToPresident
        ? _c(
            "el-form-item",
            { attrs: { label: "Σχόλιο επιστροφής" } },
            [
              _c("el-input", {
                staticClass: "return-comment",
                attrs: {
                  type: "textarea",
                  placeholder:
                    "Σχόλιο επιστροφής της αίτησης στον Πρόεδρο (υποχρεωτικό)",
                  size: "100",
                  autosize: { minRows: 4, maxRows: 10 }
                },
                model: {
                  value: _vm.returnComment,
                  callback: function($$v) {
                    _vm.returnComment = $$v
                  },
                  expression: "returnComment"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          !_vm.isCurrentUserLeader
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    round: "",
                    disabled: !_vm.tempEnabled
                  },
                  on: {
                    click: function($event) {
                      _vm.tempSave()
                    }
                  }
                },
                [_vm._v("\n      Αποδοχή εισήγησης\n    ")]
              )
            : _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "danger",
                    round: "",
                    disabled: !_vm.finalEnabled
                  },
                  on: {
                    click: function($event) {
                      _vm.finalSave()
                    }
                  }
                },
                [_vm._v("\n      Οριστική Υποβολή\n    ")]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-529331a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529331a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/ReappraisalBoardMemberJudgment.vue
// module id = null
// module chunks = 